export default "__VITE_ASSET__BD4OcjpY__"